export default [{
  path: '/videoDetail',
  name: 'videoDetail',
  meta: {
    index: 2001
  },
  params:{},
  component: () => import('@/views/video-play-detail/index'),
}]
